import { z } from "zod";
// Session-authed operator payloads: the ADR-011 login and the /api/admin/*
// settings + agent-registration routes.
export const loginBodySchema = z.object({
    email: z.string().email(),
    password: z.string().min(1).max(1024),
});
export const githubTokenBodySchema = z.object({
    token: z.string().min(20).max(512),
});
export const dokployBodySchema = z.object({
    api_url: z.string().url().max(512),
    api_key: z.string().min(8).max(512),
});
export const anthropicBodySchema = z.object({
    api_key: z.string().min(20).max(512),
    model: z.string().min(1).max(128).optional(),
    enabled: z.boolean().optional(),
});
export const registerAgentBodySchema = z.object({
    agent_id: z
        .string()
        .min(2)
        .max(64)
        .regex(/^[a-z0-9][a-z0-9_.-]*$/i, "lowercase letters, digits, dot, dash, underscore"),
    hostname: z.string().min(1).max(256),
});
export const adminAgentIdParamSchema = z.object({
    // Not registerAgentBodySchema's 64: scripts/register-agent.ts takes any id,
    // and the agent itself is accepted up to agentSnapshotSchema's 256 — an
    // agent registered from the CLI must still be deletable from Settings.
    agent_id: z.string().min(1).max(256),
});
//# sourceMappingURL=admin.js.map